/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CropRotate from '@material-ui/icons/CropRotate';
import CardBody from '../../../components/Card/CardBody';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import SimCardChangeMsisdn from '../../SimCard/component/SimCardChangeMsisdn';
import Card from '../../../components/Card/Card';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';

type ImsiSimCardChangeMsisdnType = {
    simCardUri: string;
};

export const ImsiSimCardChangeMsisdn: FunctionComponent<ImsiSimCardChangeMsisdnType> = ({ simCardUri }): React.ReactElement => {
    const [simCard, setSimCard] = useState<SimCardInterface | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const itemLoader = new ItemLoaders(dispatch);
        const loadItems = (): void => {
            itemLoader.getWithCallback(
                FormGeneralHelper.getByUri(simCardUri),
                'sim_card_change_imsi_get',
                (data: SimCardInterface) => setSimCard(data),
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        };
        if (!simCard) {
            loadItems();
        }
    }, [dispatch, simCardUri, simCard]);

    return (
        <React.Fragment>
            {simCard && simCard.active && !simCard.deleted && (
                <Card>
                    <CardHeader icon={<CropRotate />} trans="pools:sim.change_msissdn" />
                    <CardBody>
                        {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_CHANGE_MSISDN) && (
                            <SimCardChangeMsisdn item={simCard} callback={(): void => {}} />
                        )}
                    </CardBody>
                </Card>
            )}
        </React.Fragment>
    );
};
